module.exports = __webpack_public_path__ + "img/east_india_company_cemetery_old_protestant_cemetery.f856bf2c.jpg";